import { VIEW_PUBLISHED_JOBS,SEARCH_APPLY_JOBS_API } from "../../../utils/routes"; 
import getDispatch from "../common/getDispatch"
import setErrorMessage from "../common/setErrorMessage"
import {VIEW_PUBLISH_TYPE,SEARCH_APPLY_JOBS} from "../types"
import axios from 'axios'

export const viewPublishJobsAction = () => (dispatch) =>{
axios
  .get(VIEW_PUBLISHED_JOBS,{withCredentials:true})
  .then((res)=>{
  dispatch(getDispatch(VIEW_PUBLISH_TYPE,res))

 }) .catch((err)=>{
dispatch(setErrorMessage(err))
})
}

export const searchApplyJobs = (data) => (dispatch) => {
  axios
  .post( `${SEARCH_APPLY_JOBS_API}`,data,{ withCredentials: true })
  .then((res) => {
    if(!res.data.length){
      dispatch({
        type:"EMPTY_ARRAY",
        payload:"Data not found"
      })
    setTimeout(()=>{
        dispatch({
          type:"EMPTY_ARRAY",
          payload:""
        })
      },3000)
      }
      else{
        dispatch(getDispatch(SEARCH_APPLY_JOBS,res))
      }
  })
  .catch((err) => {
    dispatch(setErrorMessage(err));
  });
}